<!--
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-04 11:21:03
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-09 18:05:33
 * @FilePath: \krpano-vue - 副本\src\components\Tools.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
  <div class="tools-box">
    <i class="btn iconfont icon-dianhua" @click="clickPhone"></i>
    <!-- 音频 -->
    <!-- <i
      v-if="isAudioPlay"
      class="btn iconfont icon-yinliang"
      @click="clickAudio(false)"
    >
  </i>
    <i
      v-else
      class="btn iconfont icon-jingyin1"
      @click="clickAudio(true)"
    ></i> -->
    <!-- <i class="btn" @click="clickVR(true)">VR</i> -->
    <i class="btn iconfont icon-zhifeiji" @click="gotoMap"></i>
   
    <!-- <i class="btn iconfont icon-zhuanfa" ></i> -->
  </div>
   <Maps v-if="showMap" @gotoCom="gotoCom"/>
</div>
</template>

<script>
import Maps from '@/components/Maps.vue';
export default {
  name: "Tools",
  components:{
    Maps
  },
  data() {
    return {
      isAudioPlay: true, // 是否播放音频(默认关闭)
      number:'18148729058',
      showMap: false
    };
  },         
  methods: {
    clickPhone(){
      location.href = `tel:${this.number}`;
    },

    clickAudio(isAudioPlay) {
      this.isAudioPlay = isAudioPlay
      this.$EventBus.$emit('playMusic',{
        goPlay: isAudioPlay
      })   
    },
    gotoMap(){
      this.showMap = true
    },
    gotoCom(obj){
      this.showMap = obj.showCom
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/font_chooseList/iconfont.css';
.tools-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 6rem;
  right: 0.3rem;
  z-index: 1;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.3rem;
    height: 2.3rem;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    margin: 5px;
    text-align: center;
    line-height: 30px;
    color:#fff;
    font-size: 20px;
  }

}
</style>
